import ErrorTypes from './ErrorTypes';

export function setError (error, errorInfo) {
  return {
    type: ErrorTypes.SET_ERROR,
    payload: { error, errorInfo }
  };
}
